export const VISIBLE_TAGS = 3;

export const DAY_MONTH_FORMAT = 'MMM d';

export const YEAR_FORMAT = 'yyyy';
